// Module
var code = `<div class="info-control">
    {{#each data: i}}
        <div class="info-control-column">
            <div class="info-control-column-body columns-{{columnsCount}}-rows-{{rowsCount}}">
                {{#each data[i].items: j}}
                    <div class="info-control-column-body-element">
                        <div class="info-control-column-body-element-title">
                            {{data[i].items[j].title}}
                        </div>
                        <div class="info-control-column-body-element-value">
                            {{data[i].items[j].value}}
                        </div>
                    </div>
                {{/each}}
            </div>
        </div>
    {{/each}}
</div>`;
// Exports
export default code;